import React, { ReactNode } from 'react';

import { TEXT_WEIGHT } from '../../constants';
import { H3 } from '../../header-text/header-text';

interface Props {
    children: ReactNode | ReactNode[];
}

export const LessonPassportHeader = React.memo(({ children }: Props) => {
    return <H3 weight={TEXT_WEIGHT.L}>{children}</H3>;
});
